import * as React from 'react';
import Box from '@mui/material/Box';
import withRoot from '../modules/withRoot';
import NavBar from '../modules/views/NavBar';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import PageHead from '../modules/views/PageHead';
import Section from '../modules/components/Section';
import StaffContainer from '../modules/views/StaffContainer';
import PageMeta from '../modules/components/PageMeta';

const members = [
  {
    photo: '/images/shuichi.png',
    role: '代表取締役',
    name: '飯田 修一',
    eng: 'iida shuichi',
    link: 'https://www.instagram.com/kemiriko',
    shikaku: ['一級建築士', '2級建築施工管理技士', '石綿含有建材調査者'],
  },
  {
    photo: '/images/keisuke.png',
    role: '設計・エクステリア・インテリア',
    name: '飯田 佳佑',
    eng: 'iida keisuke',
    link: 'https://www.instagram.com/ostrich_g',
    shikaku: ['二級建築士', '1級エクステリアプランナー', 'インテリアコーディネーター', '石綿含有建材調査者'],
  },
  {
    photo: '/images/minoru.png',
    role: 'レジェンド大工',
    name: '松田 実',
    eng: 'matsuda minoru',
    link: '',
    shikaku: ['二級建築士'],
  },
  {
    photo: '/images/hisako.png',
    role: 'お茶出し',
    name: '飯田 久子',
    eng: 'iida hisako',
    link: '',
    shikaku: ['お茶出し士'],
  },
  {
    photo: '/images/coco.png',
    role: '番犬 兼 お茶出し補佐',
    name: '飯田 ココ',
    eng: 'iida coco',
    link: 'https://www.instagram.com/security_dog_coco/',
    shikaku: ['セキュリティドッグ'],
  },
];

function Staff() {
  return (
    <React.Fragment>
      <PageMeta
        title="スタッフ紹介"
        description="飯田建築のスタッフ紹介。一級建築士・エクステリアプランナー・インテリアコーディネーターの資格を持つスタッフが、設計から施工まで一貫して担当します。"
        path="/staff"
      />
      <NavBar />
      <PageHead eyebrow="Staff" title="スタッフ紹介" lead="設計から施工まで、顔の見える少人数の工務店です。" />
      <Section bg="paper" py={0} sx={{ pt: { xs: 8, sm: 12 }, pb: { xs: 10, sm: 15 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
            rowGap: { xs: 6, sm: 8 },
            columnGap: { xs: 0, sm: 7 },
          }}
        >
          {members.map((member) => (
            <StaffContainer key={member.name} {...member} />
          ))}
        </Box>
      </Section>
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Staff);
